import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-78dad9d1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "menu-card-box"
};
const _hoisted_2 = {
  class: "menu-card-top"
};
const _hoisted_3 = {
  class: "top-title"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "item-name"
};
const _hoisted_6 = ["src"];
export default {
  setup(__props) {
    const $http = inject('$http');
    const menuMap = ref();
    const menuCard = ref([{
      id: 1,
      name: '课程平台'
    }, {
      id: 2,
      name: '教学管理'
    }, {
      id: 3,
      name: '教学应用'
    }]); // 获取菜单卡片

    const getMenuCard = async () => {
      const res = await $http.getHomeMenuCard();
      menuMap.value = res;
    };

    getMenuCard();

    const handleLink = url => {
      window.open(url, '_blank');
    };

    return (_ctx, _cache) => {
      return menuMap.value ? (_openBlock(), _createElementBlock("section", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuCard.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "menu-card-list",
          key: item.id
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)]), _createElementVNode("div", {
          class: _normalizeClass(`${item.id === 3 ? 'long-card-items' : 'menu-card-items'}`)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuMap.value[item.id], menu => {
          return _openBlock(), _createElementBlock("div", {
            class: "card-item",
            key: menu.id,
            style: _normalizeStyle({
              'background-image': `url(${menu.logoUrl})`
            }),
            onClick: $event => handleLink(menu.target_url)
          }, [_createElementVNode("span", _hoisted_5, _toDisplayString(menu.name), 1), _createElementVNode("img", {
            src: menu.logo_url,
            class: "logo-img",
            alt: ""
          }, null, 8, _hoisted_6)], 12, _hoisted_4);
        }), 128))], 2)]);
      }), 128))])) : _createCommentVNode("", true);
    };
  }

};